/*
 * Kenra Event Calendar — vanilla-JS Month / Week / Day / Agenda views.
 * Replaces the marketing site's react-big-calendar (no third-party lib, per theme rules).
 * Data comes from a <script type="application/json" data-events> block emitted by
 * snippets/kenra-event-calendar.liquid (wall-clock components in the shop timezone).
 */
(function () {
  'use strict';

  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DAYS_FULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var HOUR_H = 44; // px per hour row in week/day time grids

  function wc(o) { return o ? new Date(o.y, o.mo - 1, o.d, o.h, o.mi, 0, 0) : null; }
  function startOfDay(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
  function addDays(d, n) { return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n); }
  function addMonths(d, n) { return new Date(d.getFullYear(), d.getMonth() + n, 1); }
  function sameDay(a, b) { return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }
  function startOfWeek(d) { return addDays(startOfDay(d), -d.getDay()); }

  function fmtTime(d) {
    var h = d.getHours(), m = d.getMinutes();
    var ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    return h12 + (m ? ':' + (m < 10 ? '0' + m : m) : ':00') + ' ' + ap;
  }
  function fmtTimeShort(d) {
    var h = d.getHours(), m = d.getMinutes();
    var ap = h >= 12 ? 'p' : 'a';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    return h12 + (m ? ':' + (m < 10 ? '0' + m : m) : '') + ap;
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function eventsForDay(events, day) {
    return events.filter(function (ev) { return ev._start && sameDay(ev._start, day); })
      .sort(function (a, b) { return a._start - b._start; });
  }

  function Calendar(root) {
    var dataEl = root.querySelector('[data-events]');
    var events = [];
    try { events = JSON.parse(dataEl.textContent) || []; } catch (_e) { events = []; }
    events.forEach(function (ev) { ev._start = wc(ev.start); ev._end = wc(ev.end) || (ev._start ? new Date(ev._start.getTime() + 3600000) : null); });
    events = events.filter(function (ev) { return ev._start; });

    var viewport = root.querySelector('[data-viewport]');
    var labelEl = root.querySelector('[data-label]');
    var view = 'month';
    var ref = startOfDay(new Date());
    // Land on the soonest upcoming month if today has no events around it.
    var upcoming = events.filter(function (ev) { return ev._start >= ref; }).sort(function (a, b) { return a._start - b._start; });
    if (upcoming.length) ref = startOfDay(upcoming[0]._start);

    function setView(v) {
      view = v;
      root.querySelectorAll('[data-view]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-view') === v); });
      render();
    }
    function nav(dir) {
      if (dir === 'today') { ref = startOfDay(new Date()); }
      else {
        var s = dir === 'next' ? 1 : -1;
        if (view === 'month' || view === 'agenda') ref = addMonths(ref, s);
        else if (view === 'week') ref = addDays(ref, 7 * s);
        else ref = addDays(ref, s);
      }
      render();
    }

    function chip(ev, withTime) {
      var a = el('a', 'kenra-event-calendar__chip');
      if (ev.url) a.href = ev.url;
      if (withTime) { var t = el('span', 'kenra-event-calendar__chip-time', fmtTimeShort(ev._start)); a.appendChild(t); }
      a.appendChild(el('span', 'kenra-event-calendar__chip-title', ev.title));
      a.title = (withTime ? fmtTime(ev._start) + ' — ' : '') + ev.title;
      return a;
    }

    // ---------- MONTH ----------
    function renderMonth() {
      labelEl.textContent = MONTHS[ref.getMonth()] + ' ' + ref.getFullYear();
      var first = new Date(ref.getFullYear(), ref.getMonth(), 1);
      var gridStart = startOfWeek(first);
      var weeks = Math.ceil((first.getDay() + new Date(ref.getFullYear(), ref.getMonth() + 1, 0).getDate()) / 7);
      var today = startOfDay(new Date());

      var grid = el('div', 'kenra-event-calendar__month');
      var head = el('div', 'kenra-event-calendar__month-head');
      DAYS.forEach(function (d) { head.appendChild(el('div', 'kenra-event-calendar__month-dow', d)); });
      grid.appendChild(head);

      for (var w = 0; w < weeks; w++) {
        var row = el('div', 'kenra-event-calendar__month-row');
        for (var i = 0; i < 7; i++) {
          var day = addDays(gridStart, w * 7 + i);
          var cell = el('div', 'kenra-event-calendar__month-cell');
          if (day.getMonth() !== ref.getMonth()) cell.classList.add('is-off');
          if (sameDay(day, today)) cell.classList.add('is-today');
          var num = el('div', 'kenra-event-calendar__month-date', String(day.getDate()));
          cell.appendChild(num);
          var dayEvents = eventsForDay(events, day);
          var max = 3;
          dayEvents.slice(0, max).forEach(function (ev) { cell.appendChild(chip(ev, true)); });
          if (dayEvents.length > max) {
            var more = el('button', 'kenra-event-calendar__more', '+' + (dayEvents.length - max) + ' more');
            (function (d2) { more.addEventListener('click', function () { ref = startOfDay(d2); setView('day'); }); })(day);
            cell.appendChild(more);
          }
          row.appendChild(cell);
        }
        grid.appendChild(row);
      }
      viewport.appendChild(grid);
    }

    // ---------- TIME GRID (week / day) ----------
    function renderTimeGrid(days) {
      var today = startOfDay(new Date());
      var wrap = el('div', 'kenra-event-calendar__timegrid' + (days.length === 1 ? ' is-day' : ''));

      // header row (corner + day headers)
      var header = el('div', 'kenra-event-calendar__tg-header');
      header.appendChild(el('div', 'kenra-event-calendar__tg-corner'));
      days.forEach(function (day) {
        var h = el('div', 'kenra-event-calendar__tg-dayhead' + (sameDay(day, today) ? ' is-today' : ''));
        h.appendChild(el('span', 'kenra-event-calendar__tg-dow', DAYS[day.getDay()]));
        h.appendChild(el('span', 'kenra-event-calendar__tg-date', String(day.getDate())));
        header.appendChild(h);
      });
      wrap.appendChild(header);

      // scrollable body: gutter (hour labels) + day columns
      var body = el('div', 'kenra-event-calendar__tg-body');
      body.style.setProperty('--cols', days.length);
      var gutter = el('div', 'kenra-event-calendar__tg-gutter');
      for (var hr = 0; hr < 24; hr++) {
        var lab = el('div', 'kenra-event-calendar__tg-hour');
        var d = new Date(2000, 0, 1, hr);
        lab.appendChild(el('span', null, hr === 0 ? '' : fmtTime(d)));
        gutter.appendChild(lab);
      }
      body.appendChild(gutter);

      days.forEach(function (day) {
        var col = el('div', 'kenra-event-calendar__tg-col');
        for (var hr2 = 0; hr2 < 24; hr2++) col.appendChild(el('div', 'kenra-event-calendar__tg-slot'));
        var dayEvents = eventsForDay(events, day);
        var laidOut = layoutOverlaps(dayEvents);
        dayEvents.forEach(function (ev, idx) {
          var startMin = ev._start.getHours() * 60 + ev._start.getMinutes();
          var rawEndMin = ev._end.getHours() * 60 + ev._end.getMinutes();
          // Default to a 1h block when the end isn't a valid same-day time after the start
          // (handles a missing end, a cross-midnight end, or a 00:00 end that would read as falsy-zero).
          var endMin = rawEndMin > startMin ? rawEndMin : startMin + 60;
          endMin = Math.max(endMin, startMin + 30);
          var block = el('a', 'kenra-event-calendar__tg-event');
          if (ev.url) block.href = ev.url;
          block.style.top = (startMin / 60 * HOUR_H) + 'px';
          block.style.height = Math.max(18, (endMin - startMin) / 60 * HOUR_H - 2) + 'px';
          var lo = laidOut[idx];
          block.style.left = (lo.col / lo.cols * 100) + '%';
          block.style.width = 'calc(' + (1 / lo.cols * 100) + '% - 3px)';
          block.appendChild(el('span', 'kenra-event-calendar__tg-event-time', fmtTime(ev._start)));
          block.appendChild(el('span', 'kenra-event-calendar__tg-event-title', ev.title));
          col.appendChild(block);
        });
        body.appendChild(col);
      });
      wrap.appendChild(body);
      viewport.appendChild(wrap);
      // scroll to first event (or 8am)
      var firstEv = days.map(function (d) { return eventsForDay(events, d)[0]; }).filter(Boolean).sort(function (a, b) { return a._start - b._start; })[0];
      var scrollHr = firstEv ? Math.max(0, firstEv._start.getHours() - 1) : 8;
      body.scrollTop = scrollHr * HOUR_H;
    }

    // simple overlap columns: assign each event a column index among concurrent events
    function layoutOverlaps(dayEvents) {
      var res = dayEvents.map(function () { return { col: 0, cols: 1 }; });
      for (var i = 0; i < dayEvents.length; i++) {
        var group = [i];
        for (var j = 0; j < dayEvents.length; j++) {
          if (j === i) continue;
          if (dayEvents[j]._start < dayEvents[i]._end && dayEvents[j]._end > dayEvents[i]._start) group.push(j);
        }
        var cols = group.length;
        // assign column = order within the overlapping group
        var order = group.sort(function (a, b) { return dayEvents[a]._start - dayEvents[b]._start || a - b; });
        res[i].cols = cols;
        res[i].col = order.indexOf(i);
      }
      return res;
    }

    // ---------- AGENDA ----------
    function renderAgenda() {
      var rangeStart = startOfDay(ref);
      var rangeEnd = addMonths(new Date(ref.getFullYear(), ref.getMonth(), 1), 1);
      labelEl.textContent = MONTHS[ref.getMonth()] + ' ' + ref.getFullYear();
      var list = events.filter(function (ev) { return ev._start >= rangeStart && ev._start < rangeEnd; })
        .sort(function (a, b) { return a._start - b._start; });

      if (!list.length) {
        viewport.appendChild(el('p', 'kenra-event-calendar__empty body-regular text-dark-gray text-center', 'No events scheduled for this period.'));
        return;
      }
      var table = el('div', 'kenra-event-calendar__agenda');
      var head = el('div', 'kenra-event-calendar__agenda-head');
      ['Date', 'Time', 'Event'].forEach(function (h) { head.appendChild(el('div', 'kenra-event-calendar__agenda-h', h)); });
      table.appendChild(head);
      list.forEach(function (ev) {
        var row = el('a', 'kenra-event-calendar__agenda-row');
        if (ev.url) row.href = ev.url;
        row.appendChild(el('div', 'kenra-event-calendar__agenda-date', DAYS[ev._start.getDay()] + ' ' + MONTHS[ev._start.getMonth()].slice(0, 3) + ' ' + ev._start.getDate()));
        row.appendChild(el('div', 'kenra-event-calendar__agenda-time', fmtTime(ev._start) + ' – ' + fmtTime(ev._end)));
        row.appendChild(el('div', 'kenra-event-calendar__agenda-title', ev.title));
        table.appendChild(row);
      });
      viewport.appendChild(table);
    }

    function render() {
      viewport.innerHTML = '';
      if (view === 'month') renderMonth();
      else if (view === 'week') {
        var ws = startOfWeek(ref);
        var days = []; for (var i = 0; i < 7; i++) days.push(addDays(ws, i));
        labelEl.textContent = MONTHS[days[0].getMonth()] + ' ' + days[0].getDate() + ' – ' + (days[6].getMonth() !== days[0].getMonth() ? MONTHS[days[6].getMonth()] + ' ' : '') + days[6].getDate() + ', ' + days[6].getFullYear();
        renderTimeGrid(days);
      } else if (view === 'day') {
        labelEl.textContent = DAYS_FULL[ref.getDay()] + ', ' + MONTHS[ref.getMonth()] + ' ' + ref.getDate() + ', ' + ref.getFullYear();
        renderTimeGrid([ref]);
      } else renderAgenda();
    }

    root.querySelectorAll('[data-nav]').forEach(function (b) { b.addEventListener('click', function () { nav(b.getAttribute('data-nav')); }); });
    root.querySelectorAll('[data-view]').forEach(function (b) { b.addEventListener('click', function () { setView(b.getAttribute('data-view')); }); });
    render();
  }

  function init() {
    document.querySelectorAll('[data-kenra-event-calendar]').forEach(function (root) {
      if (root.__kenraCal) return; root.__kenraCal = true; Calendar(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
